export default "__VITE_ASSET__Bqz7Whke__"